import { FC } from 'react';
import { Thing, WithContext } from 'schema-dts';

/**
 * Safely serializes Schema.org structured data to JSON-LD script tag
 * Prevents XSS by escaping dangerous characters
 */
export function generateJsonLd<T extends Thing>(
  data: WithContext<T>
): string {
  return JSON.stringify(data, null, 2).replace(
    /</g,
    '\\u003c'
  );
}

/**
 * React component props for JSON-LD script injection
 */
interface JsonLdProps {
  data: WithContext<Thing>;
}

/**
 * React component that renders JSON-LD structured data
 * Usage: <JsonLd data={generateSoftwareApplicationSchema({ locale: 'sk' })} />
 */
export const JsonLd: FC<JsonLdProps> = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: generateJsonLd(data) }}
  />
);
